import React from 'react';
import { Helmet } from 'react-helmet';

const MetaDetails = ({ title, description, keywords }) => {
  console.log('keywords are', keywords)
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

export default MetaDetails;
